import React from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};

var Spinner = function Spinner(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return React.createElement('svg', {
    height: size,
    viewBox: '0 0 16 16',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('g', {
    opacity: '0.5'
  }, React.createElement('mask', {
    id: 'mask0_1178_102583',
    style: {
      maskType: 'alpha'
    },
    maskUnits: 'userSpaceOnUse',
    x: '0',
    y: '0',
    width: '16',
    height: '16'
  }, React.createElement('path', {
    d: 'M0 0H8V8H16V16H0V0Z',
    fill: '#C4C4C4'
  })), React.createElement('g', {
    mask: 'url(#mask0_1178_102583)'
  }, React.createElement('circle', {
    cx: '8',
    cy: '8',
    r: '7.5',
    stroke: color
  }))), React.createElement('mask', {
    id: 'mask1_1178_102583',
    style: {
      maskType: 'alpha'
    },
    maskUnits: 'userSpaceOnUse',
    x: '8',
    y: '0',
    width: '8',
    height: '8'
  }, React.createElement('path', {
    d: 'M12 0H8V8H16V4V0H12Z',
    fill: '#C4C4C4'
  })), React.createElement('g', {
    mask: 'url(#mask1_1178_102583)'
  }, React.createElement('circle', {
    cx: '8',
    cy: '8',
    r: '7',
    stroke: color,
    strokeWidth: '2'
  })));
};

Spinner.propTypes = propTypes;
export default Spinner;